import styled, { css } from 'styled-components';
import { device } from '../../../styles/devices';
import { COLORS, SIZING } from '../../../styles/variables';

export const TabsContainer = styled.div`
  width: 100%;
  @media ${device.tablet} {
  }
  display: flex;
`;

export const Tab = styled.button<{ isSelected?: boolean }>`
  background-color: transparent;
  text-align: center;
  border: none;
  padding: 17px 0px 4px 0px;
  flex-grow: 1;
  cursor: pointer;
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.003px;
  border-bottom: 2px solid ${({ isSelected }) => (isSelected ? COLORS.black : COLORS.grey15)};
  margin-bottom: 4px;
`;
